import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/orders')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/orders' || location.pathname === '/orders/') {
      throw redirect({
        to: '/orders/sales-orders/active',
        search: { aiSummaryId: undefined, aiOrderNumber: undefined },
      });
    }
  },
});
